/**
 * useAccountPersonType — tipo de persona CANÓNICO del usuario autenticado,
 * leído del BE (`party.person_type` de `GET /api/v1/me`): 'pf' | 'pfae' | 'pm'.
 *
 * OJO: es DISTINTO de `usePersonType()` (apps/web), que lee la elección de
 * REGISTRO desde sessionStorage ('individual' | 'business'). Aquél sirve durante
 * el onboarding; éste es la verdad del backend una vez la cuenta existe — úsalo
 * para gatear UI exclusiva de Persona Moral (PM) en usuarios ya autenticados.
 *
 * Reusa la misma query `clientApi.me()` (queryKey `['auth','me']`) que
 * `useCurrentPartyProfile`, así no dispara un fetch extra cuando ese hook ya
 * hidrató el perfil.
 */
import { useQuery } from '@tanstack/react-query';

import { clientApi } from '@tankef/api-client';

export type AccountPersonType = 'pf' | 'pfae' | 'pm';

export interface AccountPersonTypeResult {
  personType: AccountPersonType | undefined;
  isPm: boolean;
  isLoading: boolean;
}

export function useAccountPersonType(enabled = true): AccountPersonTypeResult {
  const query = useQuery({
    queryKey: ['auth', 'me'],
    queryFn: () => clientApi.me(),
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });

  const personType = query.data?.personType;

  return {
    personType,
    isPm: personType === 'pm',
    isLoading: query.isLoading,
  };
}
